import { RUM_INTERNAL_DATA_KEY } from '../constants';
export function saveInternalRumData(key, value) {
    if (!window[RUM_INTERNAL_DATA_KEY]) {
        window[RUM_INTERNAL_DATA_KEY] = {};
    }
    window[RUM_INTERNAL_DATA_KEY][key] = value;
}
export function getInternalRumData(key) {
    var _a;
    return (_a = window[RUM_INTERNAL_DATA_KEY]) === null || _a === void 0 ? void 0 : _a[key];
}
//# sourceMappingURL=internal-rum-data.js.map